import {useEffect} from 'react';

// Ширина угла кнопок слева внизу на десктопе (чат, реакции, слои поля — см.
// Footer, field-corner-controls_desktop). По ней панель записи матча встает
// правее угла (ReplayPlaybackPanel.css): число кнопок в углу разное — чат
// есть не в каждой партии
export const FIELD_CORNER_CONTROLS_WIDTH_VAR = '--field-corner-controls-width';

/**
 * Публикует ширину угла кнопок CSS-переменной на корне экрана матча
 * (.game-ui) и обновляет ее при изменении размеров угла. Развернутые панели
 * угла выходят из потока — ширину меняют только сами кнопки
 * @param {HTMLElement|null} element - угол кнопок
 */
export const useFieldCornerControlsWidth = (element) => {
  useEffect(() => {
    const root = element?.closest('.game-ui');
    if (!root) {
      return undefined;
    }
    const update = () => {
      root.style.setProperty(FIELD_CORNER_CONTROLS_WIDTH_VAR, `${element.offsetWidth}px`);
    };
    update();
    const observer = typeof ResizeObserver === 'function' ? new ResizeObserver(update) : null;
    observer?.observe(element);
    return () => {
      observer?.disconnect();
      root.style.removeProperty(FIELD_CORNER_CONTROLS_WIDTH_VAR);
    };
  }, [element]);
};
